const most_liked_cat_slider = [
    {
        img: "https://desi-fresh.b-cdn.net/sliders/most-liked-category/rte_1.png",
        url: "/category/ready-to-eat-wze9jb_20",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/most-liked-category/rte_2.png",
        url: "/category/sweets-snacks-wD7Azo_21",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/most-liked-category/rte_3.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/most-liked-category/rte_4.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/most-liked-category/rte_5.png",
        url: "/category/vegan-vegetarian-3hFwAh_27",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/most-liked-category/rte_6.png",
        url: "/category/pickles-sauces-canned-food-8902lB_18",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/most-liked-category/rte_7.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/most-liked-category/rte_8.png",
        url: "/category/food-grains-oils-spices-3vdpnn_17",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/most-liked-category/rte_9.png",
        url: "/category/spices-condiments-j2kcwu_12",
    },
];

const regional_recipes_slider = [
    {
        img: "https://desi-fresh.b-cdn.net/sliders/regional-receipes/rc_1.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/regional-receipes/rc_2.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/regional-receipes/rc_3.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/regional-receipes/rc_4.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/regional-receipes/rc_5.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/regional-receipes/rc_6.png",
        url: "/",
    },
];

const bring_change_slider = [
    {
        img: "https://desi-fresh.b-cdn.net/sliders/bring-change/bb_1.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/bring-change/bb_2.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/bring-change/bb_3.png",
        url: "/",
    },
];

const upcoming_categories_slider = [
    {
        img: "https://desi-fresh.b-cdn.net/sliders/upcoming-categories/rte2_1.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/upcoming-categories/rte222.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/upcoming-categories/rte2_3.png",
        url: "/",
    },
    {
        img: "https://desi-fresh.b-cdn.net/sliders/upcoming-categories/rte2_4.png",
        url: "/",
    },
];

const faqs = [
    {
        q: "What sets Desi Fresh apart from other grocery stores?",
        a: "Desi Fresh is a multicultural grocery store that offers a unique selection of ingredients and spices & products from all over the Asia. We focus on providing fresh, high-quality products that cater to a wide range of cultural cuisines and uses.",
    },
    {
        q: "What type of products does Desi Fresh offer?",
        a: "Desi Fresh offers a variety of fresh produce, exotic spices, and unique ingredients, health and other eccomerce products from various cultural cuisines.  We have everything from authentic groceries to other products from all over the world.",
    },
    {
        q: "Is Desi Fresh committed to high-quality products?",
        a: "Absolutely! We are committed to providing our customers with only the freshest and highest-quality products. Our team of quatity experts carefully selects and sources all of our products to ensure that you are getting the best possible in the market.",
    },
    {
        q: "How does Desi Fresh ensure the freshness of products?",
        a: "We work closely with our suppliers to ensure that we are getting only the freshest products. Our store are designed to maintain the freshness of our products, and our team regularly checks and replaces any items that are past their prime.",
    },
    {
        q: "Does Desi Fresh offer delivery services?",
        a: "Enjoy Convenient Delivery Services with Desi Fresh in Germany! With a purchase of 49 Euro or more, receive Free Standard Delivery that arrives in 3-4 days. Need it faster? Choose our Express Delivery option for 5.50 Euro, with delivery times between 12 to 48 hours. Order online or in-store and let our team bring your groceries right to your doorstep. If you're in the Munich region, enjoy even quicker delivery times with our free delivery option, arriving in just 1-2 days.",
    },
    {
        q: "What is the Desi Fresh Return Policy?",
        a: "At Desi Fresh, customer satisfaction is our top priority. If you receive a faulty or damaged product, our hassle-free return policy has got you covered. Just bring the item back to our store within a reasonable timeframe, and we'll process a refund or exchange for you. For perishable food items, we do not accept returns.",
    },
    {
        q: "Does Desi Fresh have a commitment to sustainability?",
        a: "Yes, at Desi Fresh, we are committed to making a positive impact on the environment. We use eco-friendly packaging materials, and we actively work to reduce our carbon footprint and waste. We also support farmers and suppliers to promote sustainable agriculture practices.",
    },
    {
        q: "What is the Desi Family Loyalty Rewards program?",
        a: "At Desi Fresh, we value our customers and reward their loyalty. Our Desi Family Loyalty Rewards program allows customers to earn points for every purchase made in-store or online. These points can be redeemed for discounts on future purchases, special promotions, and other rewards. Join now and start earning rewards for your loyalty to Desi Fresh!",
    },
    {
        q: "What is Desi Hands, and how can you be a part of it",
        a: "At Desi Fresh, we believe in giving back and making a positive impact in our communities. That's why we've created Desi Hands, our community outreach program that supports charitable organizations in India, Pakistan, Bangladesh, Nepal, and Sri Lanka. By choosing to shop with us, you're not only filling your pantry, but you're also supporting children in need by providing them with food, education, and healthcare. Let's work together to create a brighter future for those who need it most. Join the Desi Hands movement today and be a part of something truly meaningful.",
    },
    {
        q: "Can I suggest new products?",
        a: "Yes! We welcome product suggestions from our customers. Contact us to recommend new items.",
    },
];

export { most_liked_cat_slider, regional_recipes_slider, bring_change_slider, upcoming_categories_slider, faqs };
